<template>
  <div class="group-comment-sidebar">
    <b-sidebar
      position="absolute"
      :right="true"
      :fullheight="true"
      :overlay="false"
      :open="isOpen"
      @close="sidebarCancel"
    >
      <div>
        <b-input v-model="searchInput" placeholder="Søg på Navn eller Nummer" class="search-bar"></b-input>
        <div>
          <b-button @click="search" class="search-button" >
            Søg
          </b-button>
        </div>

        <div>
          <b-button @click="removeAllSelectedCheckboxes" class="table-related-button button">
            Fravælg alle
          </b-button>
        </div>

        <b-table v-if="displayedGroupMembers !== undefined" class="sidebar-table table" :data="displayedGroupMembers" hoverable>
          <b-table-column field="number" label="Nummer" v-slot="props">
            {{ props.row.number }}
          </b-table-column>

          <b-table-column field="name" label="Navn" v-slot="props">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column field="isSelected" label="Valgt" v-slot="props">
            <b-field>
              <b-checkbox
                :value="props.row.isSelected"
                @input="(value) => markAssistant(props.row.number)"
              >
              </b-checkbox>
            </b-field>
          </b-table-column>
        </b-table>

        <button @click="cancel" class="acceptance-button button is-primary">Anuller</button>
        <button @click="update" class="acceptance-button button is-primary">Vis</button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from '../../enums/APISTATE';

export default {
  name: "general-statistics-filter-sidebar",
  props: {},
  data: () => ({
    searchInput: "",
    displayedGroupMembers: []
  }),
  mounted() {},
  computed: {
    ...mapGetters("generalStatisticsFilteringSidebar", [
      "isOpen",
      "groupMembers",
      "availableGroupMembers"
    ]),
  },
  methods: {
    ...mapActions("generalStatisticsFilteringSidebar", [
      "sidebarCancel",
      "markAssistantNumber",
      "searchForEmployee",
      "updateParentView",
      "rejectAll"
    ]),
    markAssistant(value){
      this.markAssistantNumber(value);
      this.displayedGroupMembers = undefined
      this.displayedGroupMembers = this.groupMembers
    },
    removeAllSelectedCheckboxes(){
      this.rejectAll();
      this.displayedGroupMembers = undefined
      this.displayedGroupMembers = this.groupMembers
    },
    update() {
      this.searchInput = "";
      this.updateParentView()
    },
    cancel() {
      this.searchInput = "";
      this.sidebarCancel();
    },
    search(){
      this.searchForEmployee(this.searchInput)
    }
  },
  watch: {
    'groupMembers'(newValue){
      this.displayedGroupMembers = newValue
    }
  }
};
</script>

<style lang="scss">
.search-button{
  margin-bottom:15px;
}
.sidebar-table {
margin:35px 15px 15px 15px;
}
.table-related-button {
  float:right; 
  margin-right:15px;
}
.search-bar {
  margin: 10px 50px 10px 50px;
}
.acceptance-button {
  margin:7px 10px 7px 10px;
}
</style>
